// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class DeviceResource extends Resource {
    basePath: string = 'devices/devices/';

    objectPath: string = 'devices/devices/{ident}/';
}
